import type { AdminUserMetabaseCollection, PortalOption } from '@branditdev/mf-types'
import type { CSSProperties } from 'react'
import { Link } from 'react-router-dom'

const tabStyle = (isActive: boolean): CSSProperties => ({
  cursor: 'pointer',
  padding: '10px 15px',
  border: '1px solid #dee2e6',
  borderBottom: isActive ? '1px solid #fff' : '1px solid #dee2e6',
  borderTopLeftRadius: '0.25rem',
  borderTopRightRadius: '0.25rem',
  backgroundColor: isActive ? '#ffffff' : '#f8f9fa',
  transition: 'background-color 0.3s ease'
})

const messageTabStyle: CSSProperties = {
  padding: '10px 15px',
  border: '1px solid #dee2e6',
  borderTopLeftRadius: '0.25rem',
  borderTopRightRadius: '0.25rem',
  backgroundColor: '#f8f9fa'
}

type AdminUserDashboardTabsProps = {
  activeCollectionId: string | null
  activePortalId: number | null
  adminPortals: PortalOption[]
  adminPortalsError: string | null
  adminPortalsLoading: boolean
  isReportsPage: boolean
  metabaseCollections: AdminUserMetabaseCollection[]
  metabaseCollectionsError: string | null
  metabaseCollectionsLoading: boolean
  onReportTabClick: (collectionId: string) => void
}

const AdminUserDashboardTabs = ({
  activeCollectionId,
  activePortalId,
  adminPortals,
  adminPortalsError,
  adminPortalsLoading,
  isReportsPage,
  metabaseCollections,
  metabaseCollectionsError,
  metabaseCollectionsLoading,
  onReportTabClick
}: AdminUserDashboardTabsProps) => {
  if (isReportsPage) {
    if (metabaseCollectionsLoading) {
      return (
        <span className="nav-item nav-link" style={messageTabStyle}>
          Loading collections...
        </span>
      )
    }

    if (metabaseCollections.length === 0) {
      return (
        <span className="nav-item nav-link" style={messageTabStyle}>
          {metabaseCollectionsError || 'No collections available'}
        </span>
      )
    }

    return (
      <>
        {metabaseCollections.map(collection => {
          const collectionId = collection.external_collection_id

          return (
            <button
              key={collection.id}
              type="button"
              onClick={() => onReportTabClick(collectionId)}
              className={`nav-item nav-link ${activeCollectionId === collectionId ? 'active' : ''}`}
              style={tabStyle(activeCollectionId === collectionId)}
            >
              {collection.name}
            </button>
          )
        })}
      </>
    )
  }

  if (adminPortalsLoading) {
    return (
      <span className="nav-item nav-link" style={messageTabStyle}>
        Loading portals...
      </span>
    )
  }

  if (adminPortals.length === 0) {
    return (
      <span className="nav-item nav-link" style={messageTabStyle}>
        {adminPortalsError || 'No admin portals available'}
      </span>
    )
  }

  return (
    <>
      {adminPortals.map(portal => (
        <Link
          key={portal.id}
          to={`/admin/${portal.id}/orders`}
          className={`nav-item nav-link ${activePortalId === portal.id ? 'active' : ''}`}
          style={tabStyle(activePortalId === portal.id)}
        >
          {portal.name || `Portal ${portal.id}`}
        </Link>
      ))}
    </>
  )
}

export default AdminUserDashboardTabs
